module.exports = __webpack_public_path__ + "img/744.90b7df84.jpg";